import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M16.25 9A6.25 6.25 0 0 1 10 15.25m0 0A6.25 6.25 0 0 1 3.75 9M10 15.25v3m0 0H6.75m3.25 0h3.25m-3.25-6A3.25 3.25 0 0 1 6.75 9V5a3.25 3.25 0 1 1 6.5 0v4A3.25 3.25 0 0 1 10 12.25Z"
	})]
});
const ForwardRef = forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
